import { post, get, baseURL } from "@/utils/request";

// Login
export const login = (data: any) => post(`/auth/login`, data);

// Register
export const register = (data: any) => post(`/auth/register`, data);

// User info
export const getUserInfo = () => get(`/user/info`, {});

// PWA Reward API
export const PWARewardAPI = () => post(`/pwaReward/claim`);

// Add user favorites
export const addUserFavorites = (data: any) => post(`/favoriteGames/add`, data);

// Logout
export const logOut = () => post(`/auth/logout`);